module.exports = __webpack_public_path__ + "img/notify.bf08f212.svg";